export const heapIdentify = (userId: string) => {
  const windowObj: any = window as any;
  if (windowObj.heap) {
    windowObj.heap.identify(userId);
  }
};

// Adding the following properties to Heap:
//  - userID and any event properties to heap
//  - isHasuraUser -- Boolean to check if the user has hasura.io email to exclude them from analytics
export const heapAddProperties = (
  userId: string,
  properties: any,
  isInternalHasuraUser: boolean
) => {
  const windowObj: any = window as any;
  if (windowObj.heap) {
    windowObj.heap.addUserProperties({
      ldUserId: userId,
      isInternalHasuraUser: isInternalHasuraUser,
    });
    windowObj.heap.clearEventProperties();
    windowObj.heap.addEventProperties(properties);
  }
};
